(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bellace-before-after"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bellace-before-after')) {
    // Switches between comparison pairs with the thumbnail buttons.
    class BellaceBeforeAfter extends HTMLElement {
      connectedCallback() {
        this.pairs = Array.from(this.querySelectorAll('.bellace-ba__pair'));
        this.thumbs = Array.from(this.querySelectorAll('[data-pair-target]'));
        this.thumbs.forEach((thumb) =>
          thumb.addEventListener('click', () => this.show(Number(thumb.dataset.pairTarget)))
        );
        this.onBlockSelect = (event) => {
          const pair = event.target.closest('.bellace-ba__pair');
          if (pair && this.contains(pair)) this.show(Number(pair.dataset.pairIndex));
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);
      }

      disconnectedCallback() {
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      show(index) {
        this.pairs.forEach((pair, i) => {
          const active = i === index;
          pair.classList.toggle('is-active', active);
          if (active) {
            pair.removeAttribute('aria-hidden');
          } else {
            pair.setAttribute('aria-hidden', 'true');
          }
          const slider = pair.querySelector('[role="slider"]');
          if (slider) slider.tabIndex = active ? 0 : -1;
        });
        this.thumbs.forEach((thumb, i) => thumb.setAttribute('aria-pressed', i === index ? 'true' : 'false'));
      }
    }

    customElements.define('bellace-before-after', BellaceBeforeAfter);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bellace-brand-story"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bellace-story')) {
    class BellaceStory extends HTMLElement {
      connectedCallback() {
        this.steps = Array.from(this.querySelectorAll('[data-story-step]'));
        this.images = Array.from(this.querySelectorAll('[data-story-image]'));
        this.activate(0);
        // The promise in the middle of the screen decides which photo shows.
        this.observer = new IntersectionObserver(
          (entries) => entries.forEach((entry) => entry.isIntersecting && this.activate(Number(entry.target.dataset.storyStep))),
          { rootMargin: '-45% 0px -45% 0px' }
        );
        this.steps.forEach((step) => this.observer.observe(step));
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      activate(index) {
        this.steps.forEach((step, i) => step.classList.toggle('is-active', i === index));
        this.images.forEach((image) => image.classList.toggle('is-active', Number(image.dataset.storyImage) === index));
      }
    }
    customElements.define('bellace-story', BellaceStory);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bellace-contact"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // Without JavaScript the browser sends the form as usual; Shopify checks the email.
    // With JavaScript, an empty or invalid email shows the same message before sending.
    document.addEventListener(
      'submit',
      (event) => {
        const form = event.target;
        if (!(form instanceof HTMLFormElement) || !form.classList.contains('bellace-contact-page__form')) return;
        const email = form.querySelector('input[type="email"]');
        if (!email || email.checkValidity()) return;
        event.preventDefault();
        const field = email.closest('.bellace-contact-page__field');
        let note = field.querySelector('.bellace-contact-page__error');
        if (!note) {
          note = document.createElement('small');
          note.className = 'bellace-contact-page__error';
          note.id = 'ContactForm-email-error';
          field.appendChild(note);
        }
        note.textContent = email.dataset.error || email.validationMessage;
        email.setAttribute('aria-invalid', 'true');
        email.setAttribute('aria-describedby', note.id);
        email.focus();
      },
      true
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bellace-faq-topics"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bellace-faq-topics')) {
    class BellaceFaqTopics extends HTMLElement {
      connectedCallback() {
        this.links = Array.from(this.querySelectorAll('[data-topic-link]'));
        this.targets = this.links.map((link) => document.getElementById(link.getAttribute('href').slice(1)));
        this.wrapper = this.targets[0]?.parentElement;
        if (!this.wrapper) return;

        // Tabs: one topic at a time. Every other topic stays in the page for search engines.
        this.wrapper.classList.add('is-tabs');
        this.links.forEach((link, index) => {
          link.addEventListener('click', (event) => {
            event.preventDefault();
            this.show(index);
            history.replaceState(null, '', link.getAttribute('href'));
          });
        });

        const fromHash = this.targets.findIndex((target) => target && '#' + target.id === window.location.hash);
        this.show(fromHash > -1 ? fromHash : 0);
      }

      show(index) {
        this.targets.forEach((target, i) => target?.classList.toggle('is-active', i === index));
        this.links.forEach((link, i) => {
          const on = i === index;
          link.classList.toggle('is-current', on);
          if (on) {
            link.setAttribute('aria-current', 'true');
            link.scrollIntoView({ block: 'nearest', inline: 'nearest' });
          } else {
            link.removeAttribute('aria-current');
          }
        });
      }
    }

    customElements.define('bellace-faq-topics', BellaceFaqTopics);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bellace-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bellace-hero')) {
    class BellaceHero extends HTMLElement {
      connectedCallback() {
        if (this.hasAttribute('data-under-header')) this.tuckUnderHeader();
        this.target = this.querySelector('[data-parallax-target]');
        this.videos = Array.from(this.querySelectorAll('video'));
        this.desktop = window.matchMedia('(min-width: 750px)');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.strength = parseFloat(getComputedStyle(this).getPropertyValue('--hero-parallax')) || 0;
        this.inView = false;

        this.onScroll = this.onScroll.bind(this);
        this.onMediaChange = this.onMediaChange.bind(this);

        this.observer = new IntersectionObserver((entries) => {
          this.inView = entries[0].isIntersecting;
          this.updateVideos();
          if (this.inView) this.onScroll();
        });
        this.observer.observe(this);

        this.desktop.addEventListener('change', this.onMediaChange);
        this.reducedMotion.addEventListener('change', this.onMediaChange);
        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.onMediaChange();
      }

      // The transparent header floats over the photo; the hero moves up by the header's height.
      // section.index is empty in the theme editor, so the "first section" check happens here instead of in Liquid.
      tuckUnderHeader() {
        const header = document.querySelector('.section-header');
        const section = this.closest('.shopify-section');
        const main = document.getElementById('MainContent');
        const firstSection = main && main.querySelector('.shopify-section');
        if (!header || !section || section !== firstSection) {
          this.removeAttribute('data-under-header');
          return;
        }
        document.documentElement.classList.add('bellace-header-over-hero');
        const setHeight = () => {
          document.documentElement.style.setProperty('--bellace-header-height', `${header.offsetHeight}px`);
        };
        setHeight();
        this.headerResize = new ResizeObserver(setHeight);
        this.headerResize.observe(header);
      }

      disconnectedCallback() {
        if (this.headerResize) {
          this.headerResize.disconnect();
          // In the editor a re-rendered hero connects before the old one is removed: keep the class if a hero is still there.
          if (!document.querySelector('bellace-hero[data-under-header]')) {
            document.documentElement.classList.remove('bellace-header-over-hero');
          }
        }
        this.observer?.disconnect();
        this.desktop.removeEventListener('change', this.onMediaChange);
        this.reducedMotion.removeEventListener('change', this.onMediaChange);
        window.removeEventListener('scroll', this.onScroll);
      }

      parallaxEnabled() {
        // Off when scroll animations are turned off in Theme settings (Animations).
        if (document.documentElement.classList.contains('bellace-static')) return false;
        return this.strength > 0 && this.desktop.matches && !this.reducedMotion.matches;
      }

      onMediaChange() {
        this.classList.toggle('bellace-hero--parallax', this.parallaxEnabled());
        if (!this.parallaxEnabled() && this.target) this.target.style.transform = '';
        this.updateVideos();
        this.onScroll();
      }

      onScroll() {
        if (!this.inView || !this.target || !this.parallaxEnabled() || this.ticking) return;
        this.ticking = true;
        requestAnimationFrame(() => {
          const rect = this.getBoundingClientRect();
          const viewport = window.innerHeight;
          // -1 when the section enters at the bottom, 1 when it leaves at the top.
          const progress = Math.max(-1, Math.min(1, (viewport / 2 - (rect.top + rect.height / 2)) / viewport));
          this.target.style.transform = `translate3d(0, ${(progress * this.strength).toFixed(1)}px, 0)`;
          this.ticking = false;
        });
      }

      updateVideos() {
        this.videos.forEach((video) => {
          if (!video.dataset.bellacePosterWatch) {
            video.dataset.bellacePosterWatch = 'true';
            video.addEventListener('playing', () => video.classList.add('is-playing'));
          }
          const visible = video.offsetParent !== null;
          if (this.inView && visible) {
            video.muted = true;
            const playing = video.play();
            if (playing) playing.catch(() => {});
          } else {
            video.pause();
          }
        });
      }
    }

    customElements.define('bellace-hero', BellaceHero);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bellace-howto-scroll"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bellace-howto-scroll')) {
    class BellaceHowtoScroll extends HTMLElement {
      connectedCallback() {
        this.steps = Array.from(this.querySelectorAll('[data-hts-step]'));
        this.images = Array.from(this.querySelectorAll('[data-hts-image]'));
        this.dots = Array.from(this.querySelectorAll('.bellace-hts__rail span'));
        this.light = window.matchMedia('(max-width: 749px), (prefers-reduced-motion: reduce)');
        this.current = 0;
        this.update = this.update.bind(this);
        window.addEventListener('scroll', this.update, { passive: true });
        this.light.addEventListener('change', this.update);
        this.update();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.update);
        this.light.removeEventListener('change', this.update);
      }

      // Scroll progress through the pinned story picks one of the four scenes.
      update() {
        if (this.light.matches) return;
        const rect = this.getBoundingClientRect();
        const progress = Math.min(0.999, Math.max(0, -rect.top / Math.max(1, rect.height - window.innerHeight)));
        const index = Math.floor(progress * this.steps.length);
        if (index === this.current) return;
        this.current = index;
        this.steps.forEach((step, i) => step.classList.toggle('is-active', i === index));
        this.images.forEach((image, i) => image.classList.toggle('is-active', i === index));
        this.dots.forEach((dot, i) => dot.classList.toggle('is-on', i <= index));
      }
    }
    customElements.define('bellace-howto-scroll', BellaceHowtoScroll);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bellace-made-of"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bellace-layers')) {
    class BellaceLayers extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
        this.media = Array.from(this.querySelectorAll('.bellace-layers__media-item'));
        this.tabList = this.querySelector('[role="tablist"]');
        if (!this.tabs.length) return;

        this.onClick = (event) => {
          const tab = event.target.closest('[role="tab"]');
          if (tab) this.select(Number(tab.dataset.index));
        };
        this.onKeydown = this.onKeydown.bind(this);
        this.onBlockSelect = (event) => {
          if (!this.contains(event.target)) return;
          const tab = event.target.closest('[role="tab"]');
          if (tab) this.select(Number(tab.dataset.index));
        };

        this.tabList.addEventListener('click', this.onClick);
        this.tabList.addEventListener('keydown', this.onKeydown);
        document.addEventListener('shopify:block:select', this.onBlockSelect);
      }

      disconnectedCallback() {
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      onKeydown(event) {
        const current = this.tabs.indexOf(document.activeElement);
        if (current === -1) return;
        const last = this.tabs.length - 1;
        let next = null;

        switch (event.key) {
          case 'ArrowRight':
          case 'ArrowDown':
            next = current === last ? 0 : current + 1;
            break;
          case 'ArrowLeft':
          case 'ArrowUp':
            next = current === 0 ? last : current - 1;
            break;
          case 'Home':
            next = 0;
            break;
          case 'End':
            next = last;
            break;
          default:
            return;
        }

        event.preventDefault();
        this.select(next, true);
      }

      select(index, moveFocus = false) {
        this.tabs.forEach((tab, i) => {
          const active = i === index;
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
          tab.tabIndex = active ? 0 : -1;
        });
        this.panels.forEach((panel, i) => panel.classList.toggle('is-active', i === index));
        this.media.forEach((item, i) => {
          item.classList.toggle('is-active', i === index);
          if (i === index) {
            item.removeAttribute('aria-hidden');
          } else {
            item.setAttribute('aria-hidden', 'true');
          }
        });

        const tab = this.tabs[index];
        if (moveFocus) tab.focus({ preventScroll: true });

        // Keep the active tab visible in the mobile swipe row without scrolling the page.
        const row = this.tabList;
        if (row.scrollWidth > row.clientWidth) {
          const left = tab.offsetLeft - (row.clientWidth - tab.offsetWidth) / 2;
          row.scrollTo({ left, behavior: 'smooth' });
        }
      }
    }

    customElements.define('bellace-layers', BellaceLayers);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bellace-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bellace-review-story')) {
    customElements.define(
      'bellace-review-story',
      class BellaceReviewStory extends HTMLElement {
        connectedCallback() {
          this.slides = [...this.querySelectorAll('[data-story-slide]')];
          this.thumbs = [...this.querySelectorAll('[data-story-thumb]')];
          this.current = 0;
          this.thumbs.forEach((thumb) => thumb.addEventListener('click', () => this.show(Number(thumb.dataset.storyThumb))));
          this.querySelector('[data-story-prev]')?.addEventListener('click', () => this.show(this.current - 1));
          this.querySelector('[data-story-next]')?.addEventListener('click', () => this.show(this.current + 1));
        }

        // Wraps around at both ends, so the arrows always lead somewhere.
        show(index) {
          const total = this.slides.length;
          if (!total) return;
          this.current = (index + total) % total;
          this.slides.forEach((slide, i) => {
            const active = i === this.current;
            slide.classList.toggle('is-active', active);
            slide.toggleAttribute('aria-hidden', !active);
          });
          this.thumbs.forEach((thumb, i) => {
            const active = i === this.current;
            thumb.classList.toggle('is-active', active);
            if (active) {
              thumb.setAttribute('aria-current', 'true');
              thumb.scrollIntoView({ block: 'nearest', inline: 'nearest' });
            } else {
              thumb.removeAttribute('aria-current');
            }
          });
        }
      }
    );
  }
  if (!customElements.get('bellace-review-more')) {
    customElements.define(
      'bellace-review-more',
      class BellaceReviewMore extends HTMLElement {
        connectedCallback() {
          this.list = this.querySelector('.bellace-rvfull__list');
          this.button = this.querySelector('[data-review-more]');
          if (!this.list || !this.button) return;
          // The button only shows when some reviews are hidden at this screen size.
          this.update = () => {
            if (this.list.classList.contains('is-open')) return;
            const hidden = [...this.list.children].some((card) => card.offsetParent === null);
            this.button.hidden = !hidden;
          };
          this.button.addEventListener('click', () => {
            this.list.classList.add('is-open');
            this.button.hidden = true;
          });
          this.update();
          window.addEventListener('resize', this.update, { passive: true });
        }

        disconnectedCallback() {
          window.removeEventListener('resize', this.update);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bellace-split-scroll"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bellace-split-scroll')) {
    class BellaceSplitScroll extends HTMLElement {
      connectedCallback() {
        this.items = Array.from(this.querySelectorAll('[data-scroll-item]'));
        this.images = Array.from(this.querySelectorAll('[data-scroll-image]'));
        if (!this.items.length || !('IntersectionObserver' in window)) return;
        // The item crossing the middle band of the screen becomes the active one.
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) this.activate(entry.target.dataset.scrollItem);
            });
          },
          { rootMargin: '-45% 0px -45% 0px', threshold: 0 }
        );
        this.items.forEach((item) => this.observer.observe(item));
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }

      activate(index) {
        this.items.forEach((item) => item.classList.toggle('is-active', item.dataset.scrollItem === index));
        this.images.forEach((image) => image.classList.toggle('is-active', image.dataset.scrollImage === index));
      }
    }

    customElements.define('bellace-split-scroll', BellaceSplitScroll);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bellace-ugc"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bellace-video-card')) {
    // Muted, looping card video with no controls: it loads when it nears the screen
    // and plays whenever it is on screen, so the row always feels alive.
    class BellaceVideoCard extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        if (!this.video) return;
        this.loaded = false;

        this.inView = false;

        this.video.addEventListener('playing', () => this.classList.add('is-started'));
        // Retry as soon as enough data has arrived (slow mobile connections).
        this.video.addEventListener('canplay', () => this.inView && this.play());

        this.observer = new IntersectionObserver(
          (entries) => {
            this.inView = entries[0].isIntersecting;
            if (this.inView) {
              this.load();
              this.play();
            } else {
              this.video.pause();
            }
          },
          { rootMargin: '200px' }
        );
        this.observer.observe(this);
        BellaceVideoCard.cards.add(this);
      }

      play() {
        this.video.muted = true;
        this.video.play()?.catch(() => {});
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        BellaceVideoCard.cards.delete(this);
      }

      load() {
        if (this.loaded) return;
        this.loaded = true;
        this.video.querySelectorAll('source[data-src]').forEach((source) => {
          source.src = source.dataset.src;
        });
        this.video.load();
      }
    }

    BellaceVideoCard.cards = new Set();

    // Some phones (e.g. iPhone in Low Power Mode) only start video after a touch:
    // the first touch or scroll starts every card that is on screen.
    const wake = () => BellaceVideoCard.cards.forEach((card) => card.inView && card.video?.paused && card.play());
    ['touchstart', 'scroll', 'click'].forEach((type) => document.addEventListener(type, wake, { passive: true }));

    customElements.define('bellace-video-card', BellaceVideoCard);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bellace-who-for"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bellace-who-accordion')) {
    customElements.define(
      'bellace-who-accordion',
      class BellaceWhoAccordion extends HTMLElement {
        connectedCallback() {
          this.bars = [...this.querySelectorAll('details[data-index]')];
          this.stage = [...this.querySelectorAll('.bellace-who__stage-item')];
          this.bars.forEach((bar) => bar.addEventListener('toggle', () => this.sync(bar)));
          // On phones there is no photo stage beside the bars, so all start closed.
          if (window.matchMedia('(max-width: 749px)').matches) this.bars.forEach((bar) => (bar.open = false));
        }

        // One bar open at a time; the photo on the right follows the open bar.
        sync(bar) {
          if (bar.open) {
            this.bars.forEach((other) => {
              if (other !== bar) other.open = false;
            });
          }
          const active = this.bars.find((other) => other.open);
          if (!active) return;
          this.stage.forEach((item) => item.classList.toggle('is-active', item.dataset.index === active.dataset.index));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bellace-wig-guide"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bellace-guide-tips')) {
    // Phones start with every tip closed; larger screens keep them all open.
    class BellaceGuideTips extends HTMLElement {
      connectedCallback() {
        this.desktop = window.matchMedia('(min-width: 750px)');
        this.sync = () => this.querySelectorAll('details').forEach((tip) => (tip.open = this.desktop.matches));
        this.desktop.addEventListener('change', this.sync);
        this.sync();
      }

      disconnectedCallback() {
        this.desktop?.removeEventListener('change', this.sync);
      }
    }

    customElements.define('bellace-guide-tips', BellaceGuideTips);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bellace-wig-quiz"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bellace-quiz')) {
    // Each look matches one or more product tags, so new textures join by tagging.
    const STYLE_TAGS = {
      straight: ['straight'],
      bangs: ['bangs'],
      'body-wave': ['body-wave', 'water-wave', 'wet-and-wavy'],
      curly: ['curly', 'kinky-curly'],
      gray: ['gray', 'salt-and-pepper'],
    };

    class BellaceQuiz extends HTMLElement {
      connectedCallback() {
        this.answers = {};
        this.steps = Array.from(this.querySelectorAll('[data-step]'));
        this.dots = Array.from(this.querySelectorAll('.bellace-quiz__progress li'));
        this.result = this.querySelector('[data-result]');
        this.matches = Array.from(this.querySelectorAll('.bellace-quiz__match'));

        this.addEventListener('click', (event) => {
          const option = event.target.closest('[data-answer]');
          if (option) this.choose(option);
          if (event.target.closest('[data-restart]')) this.restart();
        });
      }

      choose(option) {
        const step = option.closest('[data-step]');
        step.querySelectorAll('[data-answer]').forEach((button) => button.setAttribute('aria-pressed', button === option));
        this.answers[step.dataset.step] = option.dataset.answer;
        const index = this.steps.indexOf(step);
        window.setTimeout(() => (index < this.steps.length - 1 ? this.show(index + 1) : this.showResult()), 250);
      }

      show(index) {
        this.steps.forEach((step, i) => (step.hidden = i !== index));
        this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i <= index));
        this.result.hidden = true;
        this.steps[index].querySelector('[data-answer]').focus();
      }

      // Score each wig: style match counts most, first-wig and length fit add to it.
      showResult() {
        const [first, style, length] = [this.answers[1], this.answers[2], this.answers[3]];
        const lengthRange = { short: [0, 12], shoulder: [13, 16], long: [17, 40] }[length];
        const scored = this.matches.map((match) => {
          const tags = match.dataset.tags.split(',');
          const inches = match.dataset.lengths.split(',').filter(Boolean).map((value) => parseInt(value, 10));
          const fitting = inches.filter((inch) => inch >= lengthRange[0] && inch <= lengthRange[1]);
          let score = 0;
          if ((STYLE_TAGS[style] || [style]).some((tag) => tags.includes(tag))) score += 4;
          if (style !== 'gray' && tags.includes('gray')) score -= 1;
          if (style === 'curly' && tags.includes('headband') && length === 'long') score += 1;
          if (first === 'first' && tags.includes('first-wig')) score += 2;
          if (fitting.length) score += 2;
          return { match, score, fitting, inches };
        });
        scored.sort((a, b) => b.score - a.score);
        const best = scored[0];

        this.matches.forEach((match) => (match.hidden = true));
        const note = best.match.querySelector('[data-length-note]');
        const shown = best.fitting.length ? best.fitting : best.inches;
        note.textContent = shown.length ? `${shown.join(' / ')} inch` : '';
        best.match.hidden = false;

        const also = this.querySelector('[data-also]');
        const others = scored.slice(1, 4).map((item) => item.match.dataset.productId);
        this.querySelectorAll('[data-also-item]').forEach((item) => (item.hidden = !others.includes(item.dataset.alsoItem)));
        also.hidden = others.length === 0;

        this.steps.forEach((step) => (step.hidden = true));
        this.dots.forEach((dot) => dot.classList.add('is-active'));
        this.result.hidden = false;
        best.match.focus();
      }

      restart() {
        this.answers = {};
        this.querySelectorAll('[aria-pressed]').forEach((button) => button.removeAttribute('aria-pressed'));
        this.show(0);
      }
    }
    customElements.define('bellace-quiz', BellaceQuiz);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (() => {
    if (window.bellacePdpZoom) return;
    window.bellacePdpZoom = true;

    // Zoom for product photos: hover on desktop, tap (and drag to pan) on touch screens.
    // Click and keyboard still open Dawn's lightbox, so zoom never depends on a mouse.
    const SELECTOR = '.bellace-pdp[data-bellace-zoom] .product__media-list .product-media-container.media-type-image';
    const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
    let lastPointerType = 'mouse';

    const setOrigin = (container, event) => {
      const rect = container.getBoundingClientRect();
      const x = Math.min(100, Math.max(0, ((event.clientX - rect.left) / rect.width) * 100));
      const y = Math.min(100, Math.max(0, ((event.clientY - rect.top) / rect.height) * 100));
      container.style.setProperty('--zoom-x', `${x}%`);
      container.style.setProperty('--zoom-y', `${y}%`);
    };

    const resetAll = (except) => {
      document.querySelectorAll(`${SELECTOR}.is-zoomed`).forEach((container) => {
        if (container !== except) container.classList.remove('is-zoomed');
      });
    };

    document.addEventListener(
      'pointerdown',
      (event) => {
        lastPointerType = event.pointerType || 'mouse';
      },
      true
    );

    document.addEventListener('pointermove', (event) => {
      const container = event.target.closest?.(SELECTOR);
      if (!container) return;
      if (event.pointerType === 'mouse' && finePointer.matches) {
        setOrigin(container, event);
        container.classList.add('is-zoomed');
      } else if (event.pointerType === 'touch' && container.classList.contains('is-zoomed')) {
        setOrigin(container, event);
      }
    });

    document.addEventListener('pointerout', (event) => {
      if (event.pointerType !== 'mouse') return;
      const container = event.target.closest?.(SELECTOR);
      if (container && !container.contains(event.relatedTarget)) container.classList.remove('is-zoomed');
    });

    // On touch, a tap zooms in place instead of opening the lightbox; a second tap zooms out.
    document.addEventListener(
      'click',
      (event) => {
        if (lastPointerType !== 'touch') return;
        const container = event.target.closest?.(SELECTOR);
        if (!container) return;
        event.preventDefault();
        event.stopPropagation();
        const zoomed = container.classList.toggle('is-zoomed');
        if (zoomed) {
          setOrigin(container, event);
          resetAll(container);
        }
      },
      true
    );

    // Swiping to another photo resets the zoom.
    document.addEventListener(
      'scroll',
      (event) => {
        if (event.target?.classList?.contains('product__media-list')) resetAll();
      },
      true
    );
  })();

  (() => {
    if (window.bellacePdpAtc) return;
    window.bellacePdpAtc = true;
    // PUB_SUB_EVENTS is a top-level const in constants.js, not a window property.
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

    // Confirmation after a successful add: "Added" on the button for a moment, plus a
    // status message for screen readers. Dawn opens the cart drawer itself.
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source !== 'product-form') return;
      document.querySelectorAll('.bellace-pdp .bellace-atc').forEach((button) => {
        const form = button.closest('product-form');
        const status = form?.parentElement?.querySelector('[data-bellace-atc-status]') || form?.querySelector('[data-bellace-atc-status]');
        if (String(form?.querySelector('[name="id"]')?.value) !== String(event.productVariantId)) return;
        clearTimeout(button.bellaceAddedTimer);
        button.classList.add('is-added');
        if (status) status.textContent = status.dataset.message || '';
        button.bellaceAddedTimer = setTimeout(() => {
          button.classList.remove('is-added');
          if (status) status.textContent = '';
        }, 2400);
      });
    });

    // Keep the price on the button in step with the selected variant.
    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      const { sectionId, html } = event.data;
      const source = html?.querySelector(`#ProductSubmitButton-${sectionId} [data-bellace-atc-price]`);
      const target = document.querySelector(`#ProductSubmitButton-${sectionId} [data-bellace-atc-price]`);
      if (source && target) target.textContent = source.textContent;
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
